import React from 'react';
import { Button, Icon, TYPE_OUTLINE } from '@mds/mds-reactjs-library';
import Outline24MoveLayerDown from '@mds/mds-icons/icons/svg/outline-24-move-layer-down.svg';
import Outline24Preview from '@mds/mds-icons/icons/svg/outline-24-preview.svg';

const PreviewDownloadButton = ({ file, download, preview }) => {

    const handlePreviewClick = (e) => {
        e.stopPropagation();
        preview(e, file);
    };

    const handleDownloadClick = (e) => {
        e.stopPropagation();
        download(e, file);
    };

    return (
        <>
            <Button iconOnly onClick={handleDownloadClick} className='download-button'>
                <Icon fill="#000000" type={TYPE_OUTLINE} src={Outline24MoveLayerDown} />
            </Button>
            <Button iconOnly onClick={handlePreviewClick}>
                <Icon fill="#000000" type={TYPE_OUTLINE} src={Outline24Preview} />
            </Button>
        </>
    );
};

export default PreviewDownloadButton;